"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_business_days_1 = __importDefault(require("moment-business-days"));
const holidays = [
    '2022-01-17',
    '2022-02-21',
    '2022-05-30',
    '2022-06-20',
    '2022-07-04',
    '2022-09-05',
    '2022-10-10',
    '2022-11-11',
    '2022-11-24',
    '2022-12-26',
    '2023-01-02',
    '2023-01-16',
    '2023-02-20',
    '2023-05-29',
    '2023-06-19',
    '2023-07-04',
    '2023-09-04',
    '2023-10-09',
    '2023-11-23',
    '2023-12-25'
];
moment_business_days_1.default.updateLocale('us', {
    holidays,
    holidayFormat: 'YYYY-MM-DD',
    workingWeekdays: [1, 2, 3, 4, 5]
});
exports.wsMoment = moment_business_days_1.default;
//# sourceMappingURL=wsMoment.js.map